import axios from "axios";
import { timeoutStandart, urlApi, getApiUrl } from ".";
import { Encrypt } from "../Crypt";

//#region "TOKEN"
export function getTokenApi(credentials) {
    return new Promise((resolve, reject) => {
      let config = {
        method: "post",
        url: getApiUrl("/api/v1/token"),
        data: { ...credentials },
        timeout: timeoutStandart,
      };
  
      axios(config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  }
  
  //#region "LOGIN"
  
  export function Login(email, senha, tokenApi) {
    return new Promise((resolve, reject) => {
        let config = {
          method: "post",
          params: { Login: email, Password: Encrypt(senha) },
          url: getApiUrl("/api/v1/users/login"),
          timeout: timeoutStandart,
          // headers: {
          //   Authorization: "Bearer " + tokenApi,
          // },
        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else if (response.status == 401) {
              reject({reason: "Sessão expirada, tente logar novamente"});
            } else {
              resolve(response.data);
            }
          })
          .catch((error) => {
            reject(error.response?.data ?? error.message ?? error);
          });
      });
  }
  
  export function Register(login, password, name, document, email, phone, tokenApi, messageType = 0) {
    return new Promise((resolve, reject) => {
        let config = {
          method: "post",
          url: getApiUrl("/api/v1/users/register"),
          params: {
            login: login,
            password: password,
            name: name,
            document: document,
            email: email,
            phone: phone,
            messageType: messageType
          },
          headers: {
            Authorization: "Bearer " + tokenApi,
          },
          timeout: timeoutStandart,
        };
        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(new Error("Ocorreu um erro, por favor contate o suporte"));
            }
          })
          .catch(function (error) {
            reject(error.response.data);
          });
      });
  }
  
  export function ForgotPassword(email, tokenApi, messageType = 0) {
    return new Promise((resolve, reject) => {
        let config = {
          method: "post",
          params: { userEmail: email, messageType: messageType },
          url: getApiUrl("/api/v1/users/forgotpassword"),
          timeout: timeoutStandart,
          headers: {
            Authorization: "Bearer " + tokenApi,
          },
        };
  
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
  }
  
  export function ChangePasswordByUser(newPassword, idUser, tokenApi) {
    return new Promise((resolve, reject) => {
        let config = {
          method: "post",
          params: { idUser: idUser, password: newPassword },
          url: getApiUrl("/api/v1/users/alteruserpassword"),
          timeout: timeoutStandart,
          headers: {
            Authorization: "Bearer " + tokenApi,
          },
        };
  
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
  }
  
  export function ConfirmEmailByUser(idUser, tokenApi) {
    return new Promise((resolve, reject) => {
        let config = {
          method: "post",
          params: { idUser: idUser },
          url: getApiUrl("/api/v1/users/confirmemail"),
          timeout: timeoutStandart,
          headers: {
            Authorization: "Bearer " + tokenApi,
          },
        };
  
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
  }
  
  export function ResendConfirmationEmail(userEmail, tokenApi, messageType = 0) {
    return new Promise((resolve, reject) => {
        let config = {
          method: "post",
          params: { userEmail: userEmail, messageType: messageType },
          url: getApiUrl("/api/v1/users/ResendConfirmationEmail"),
          timeout: timeoutStandart,
          headers: {
            Authorization: "Bearer " + tokenApi,
          },
        };
  
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
  }

  export function GetMessageType(tokenApi) {
    return new Promise((resolve, reject) => {
        let config = {
          method: "get",
          url: getApiUrl("/api/v1/users/MessageType"),
          timeout: timeoutStandart,
        };
  
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
  }
  //#endregion